/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function() {

    // check for the existence of the data attribute
    // restore broken div background images.
    var divBackgroundImage = document.querySelectorAll('[data-bgset]');

    $( divBackgroundImage ).each(function() {

        var divBgImageUrl = $(this).data('bgset');
        $(this).css("background-image", "url(" + divBgImageUrl + ")");

    });

}());